<!--
 * @Descripttion: 搜索组件属性配置
 * @Author: zenghua.wang
 * @Date: 2021-06-07 10:04:11
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-07 11:28:05
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      title="搜索设置"
      :refreshBtn="false"
    >
      <template v-slot:extend>
        <el-form-item label="size">
          <el-radio-group
            v-model="data.option.size"
            size="mini"
          >
            <el-radio-button
              v-for="(item, index) in options.sizeList"
              :key="index"
              :value="item"
              :label="item"
            ></el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="搜索">
          <el-switch
            v-model="data.option.searchBtn"
            :active-color="theme.active"
            :inactive-color="theme.inactive"
          />
        </el-form-item>

        <el-form-item label="清空">
          <el-switch
            v-model="data.option.clearBtn"
            :active-color="theme.active"
            :inactive-color="theme.inactive"
          />
        </el-form-item>

        <el-form-item label="搜索参数">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-setting"
            @click="onSetting"
          >设置</el-button>
        </el-form-item>

        <div style="margin: 8px 0">
          <el-table
            :data="data.option.column"
            v-loading="waitting"
            border
            size="small"
            style="width: 100%"
          >
            <el-table-column label="参数名">
              <template slot-scope="scope">
                {{ scope.row.label }}
              </template>
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-top"
                  @click="sortField(scope.row, scope.$index, 'up')"
                ></el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-bottom"
                  @click="sortField(scope.row, scope.$index, 'down')"
                ></el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-edit"
                  @click="editField(scope.row, scope.$index)"
                ></el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  @click="deleteField(scope.row, scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 弹窗 -->
        <condition-dialog
          :dialog="dialog"
          :data="data"
          :column="column"
          @change="updateField"
        />
      </template>
    </api-interface>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import conditionDialog from './dialog'

import { theme, component } from '@/dragComponents/model/default.js'
import apiField from '@/dragComponents/mixins/apiField.js'

export default {
  name: 'config-condition',
  mixins: [apiField],
  components: {
    configBase,
    configAuth,
    conditionDialog,
    apiInterface
  },
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      component: component,
      options: {
        sizeList: ['medium', 'small', 'mini']
      }
    }
  },
  methods: {
    onSetting() {
      let form = {
        prop: '',
        label: '',
        value: '',
        type: 'text',
        dicData: [],
        dicFrom: '静态'
      }
      this.addField(form, false)
    }
  }
}
</script>
